import type { GraphQLTaggedNode } from 'react-relay';
import { graphql } from 'react-relay';

import type {
	viewPresenceBootstrapQuery$data,
	viewPresenceBootstrapQuery$variables,
} from './__generated__/viewPresenceBootstrapQuery.graphql.ts';

export const VIEW_PRESENCE_BOOTSTRAP_QUERY: GraphQLTaggedNode = graphql`
	query viewPresenceBootstrapQuery($cloudId: ID!, $contentId: ID!, $spaceKey: String!) {
		confluence_viewPresenceBootstrap(
			cloudId: $cloudId
			contentId: $contentId
			spaceKey: $spaceKey
		) {
			isEnabledOnContentView
			token
		}
	}
`;

export type ViewPresenceBootstrapResponse = viewPresenceBootstrapQuery$data;
export type ViewPresenceBootstrapKey = viewPresenceBootstrapQuery$variables;
export type ViewPresenceBootstrap = NonNullable<
	viewPresenceBootstrapQuery$data['confluence_viewPresenceBootstrap']
>;
